import React, { useState } from "react";
import { AssetType } from "static/types";
import "./style.scss";
import AssetIcon from "../asset-icon";
import HelpCircle from "../../../../assets/HelpCircleWTB.svg";
import { formatMoney, getAvgValue } from "helpers/money";
import ExchangeStatusBtn from "widgets/market/exchange-status-btn";
import useExchangeTimeFrame from "hooks/useExchangeTimeFrame";
import { useTranslation } from "react-i18next";
import { useAssetVolatility } from "hooks/useAssetVolatility";
import usePrice from "hooks/usePrice";
import { fxOrderStore } from "entities/fx-order";
import { useStore } from "zustand";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import moment from "moment";

type PropType = {
  asset: any;
  supportingText?: string;
  percentPerAnnum?: string;
  onClick?: () => void;
  onMouseDown?: (e: React.MouseEvent) => void;
  about?: boolean;
  onAboutClick?: () => void;
};

export const MarketAsset: React.FC<PropType> = ({
  asset,
  supportingText,
  percentPerAnnum,
  onClick,
  onMouseDown,
  about,
  onAboutClick,
}) => {
  const {
    type,
    bid: bidPrice,
    ask: askPrice,
    name,
    symbol,
    isin,
    currency,
    price: assetPrice,
    change: assetChange,
  } = asset;
  const isCurrency = type === AssetType.Currency;
  const isOption = type === AssetType.Option;
  const navigate = useNavigate();
  const {
    from,
    to,
    operation,
    quantity,
    limitPrice,
    change_type,
    setChangeType,
    setFrom,
    setTo,
    setOperation,
    setQuantity,
    setLimitPrice,
    setAmount,
    amount,
    selectedOfferID,
    setSpecialOfferID: setSelectedOfferID,
    clear,
  } = useStore(fxOrderStore);

  const exchange = useExchangeTimeFrame(asset?.exchange);
  const isBond = [AssetType.Bond, AssetType.EuroBond].includes(type);
  const isStock = [AssetType.Stock, AssetType.ETF, AssetType.Fond].includes(
    type
  );
  const isAmx = asset?.exchange?.id === 25;
  const { t } = useTranslation("app");

  const { ask, bid, last, mid, change, changePercent, ask_yield } = usePrice({
    exchangeStatus: exchange?.status,
    exchange: exchange?.exchange_code,
    symbol: isOption ? null : symbol,
    assetType: type,
    ask: isOption ? null : askPrice,
    bid: isOption ? null : bidPrice,
    ask_yield: asset.data?.ask_yield || null,
    bid_yield: asset.data?.bid_yield || null,
    price: isOption ? null : assetPrice,
    change: isOption ? null : assetChange,
  });

  const { changedPart, unchangedPart, volatilityElementRef } =
    useAssetVolatility((isAmx ? ask : null) || last || mid);

  const maturity = asset.data?.maturity;
  const coupon = asset.data?.coupon;
  // const coupon_type = asset.data?.coupon_type;

  // todo | add if needed |
  // const {
  //   changedPart: bidChangedPart,
  //   unchangedPart: bidUnchangedPart,
  //   volatilityElementRef: bidVolatilityElementRef,
  // } = useAssetVolatility(bid);

  // const {
  //   changedPart: askChangedPart,
  //   unchangedPart: askUnchangedPart,
  //   volatilityElementRef: askVolatilityElementRef,
  // } = useAssetVolatility(ask);

  // <p>{symbol}</p>
  // <span>{currency.code}</span>

  return (
    <>
      {isCurrency ? (
        <div
          // onClick={onClick}
          // onMouseDown={onMouseDown}
          onClick={
            onClick
              ? () => onClick()
              : () => {
                  setFrom(asset.symbol);
                  setTo(asset.currency.code);
                  setQuantity("");
                  setAmount("");
                  navigate(PATH_LIST.currencies);
                }
          }
          className="market-asset currency-asset-new"
        >
          <div className="currency-asset-new_left">
            <span>{t("sell")}</span>
            <p>{+bid.toFixed(4)}</p>
          </div>
          <div className="currency-asset-new_middle">
            <AssetIcon asset={asset} />
            <p>
              {symbol}/{currency.code}
            </p>
          </div>
          <div
            onClick={
              onClick
                ? () => onClick()
                : (e) => {
                    e.stopPropagation();
                    setFrom(asset.currency.code);
                    setTo(asset.symbol);
                    setQuantity("");
                    setAmount("");
                    navigate(PATH_LIST.currencies);
                  }
            }
            className="currency-asset-new_right"
          >
            <span>{t("buy")}</span>
            <p>{+ask.toFixed(4)}</p>
          </div>
        </div>
      ) : isBond ? (
        <div
          onClick={onClick}
          onMouseDown={onMouseDown}
          className="market-asset"
        >
          <div className="asset-info">
            <AssetIcon asset={asset} />
            <div>
              <span className="asset-info-span">{name}</span>

              <div className={""}>
                {/* <p>
                  {symbol === isin
                    ? `${symbol}`
                    : `${symbol}${coupon ? ` | ${coupon}%` : ""}`}
                </p> */}
                <p>{isin || symbol}</p>
                {/* {isStock && exchange && (
                  <ExchangeStatusBtn assetField status={exchange.status} />
                )} */}
              </div>

              {maturity ? (
                <span className="asset-info-span">
                  {coupon ? `${coupon}% | ` : ""}{" "}
                  {moment(maturity, "YYYY-MM-DD").format("DD MMM YYYY")}
                </span>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="price-gains-wrapper">
            <div className="price-gains" style={{ rowGap: change ? "4px" : 0 }}>
              {ask_yield && (
                <p style={{ fontSize: "16px" }}>
                  <span style={{ fontWeight: "normal", fontSize: "14px" }}>
                    {t("yield2")}:{" "}
                  </span>
                  {+ask_yield.toFixed(2)}%
                </p>
              )}
              <p style={{ fontSize: "16px" }}>
                <span style={{ fontWeight: "normal", fontSize: "14px" }}>
                  {t("price")}:{" "}
                </span>
                {+(ask || last || mid).toFixed(2)}%
              </p>
              {/* <p>
                {formatMoney(
                  getAvgValue(asset.data.ask_yield, asset.data.bid_yield)
                )}
                %{" | "}
                {last | mid}
              </p> */}
            </div>

            {about && (
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  onAboutClick && onAboutClick();
                }}
                className="about-asset"
                src={HelpCircle}
                alt="Help"
              />
            )}
          </div>
        </div>
      ) : isOption ? (
        <div
          onClick={onClick}
          onMouseDown={onMouseDown}
          className="market-asset"
        >
          <div className="asset-info">
            <AssetIcon asset={asset} />
            <div>
              <p>{symbol}</p>
              <span className="asset-info-span">{name}</span>
            </div>
          </div>
        </div>
      ) : (
        <div
          onClick={onClick}
          onMouseDown={onMouseDown}
          className="market-asset"
        >
          <div className="asset-info">
            <AssetIcon asset={asset} />
            <div>
              <div className={isStock ? "asset-stock-field" : undefined}>
                <p>{symbol} </p>
                {isStock && exchange && (
                  <ExchangeStatusBtn assetField status={exchange.status} />
                )}
              </div>

              <span className="asset-info-span">
                {isStock ? (
                  <>
                    {isStock && exchange ? exchange.exchange_code + " | " : ""}
                    {name}
                  </>
                ) : (
                  name
                )}
              </span>
            </div>
          </div>

          <div className="price-gains-wrapper">
            <div className="price-gains" style={{ rowGap: change ? "4px" : 0 }}>
              <p>
                {/* {price} {percentPerAnnum ? "%" : currency.symbol} */}

                {/* ....... */}
                {/* {number}  */}
                <span style={{ color: "#2b2f38" }}>{unchangedPart}</span>
                <span id="volatility" ref={volatilityElementRef}>
                  {changedPart}
                </span>
                {/* ....... */}
                {percentPerAnnum ? "%" : currency.symbol}
              </p>
              {isStock && (
                <div className={`${change && change < 0 ? "loss" : ""}`}>
                  {percentPerAnnum ? (
                    <span>
                      {percentPerAnnum} % {t("perAnnum")}
                    </span>
                  ) : (
                    <>
                      {change ? (
                        <>
                          <span>{change}$</span>
                          <span className="gains-percent">
                            {changePercent}%
                          </span>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>

            {about && (
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  onAboutClick && onAboutClick();
                }}
                className="about-asset"
                src={HelpCircle}
                alt="Help"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
